export default __webpack_public_path__ + "static/card_reader_b.e5663998d785d58859e7420f46767ae8.svg";